module.exports = __webpack_public_path__ + "static/2-6e20346be5cd48727b78fc9699253982.jpg";